import queryString from "query-string"

const buildQueryString = (params) => (
  `?${queryString.stringify(params, { arrayFormat: "bracket" })}`
)

export default buildQueryString
